<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-15 16:57:47
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-12 10:47:59
 * @Description: 用于游戏下方的大表格，目前统计有 3️⃣ 个用处：All, High, Rare 
-->

<template>
    <!-- ↓ 用户头像+用户名列 -->
    <CasinoHistoryBodyCell
        @click="userModalControl(history?.user?._id)" 
        class="flex-[0.3] flex cursor-pointer"
    >
        <div class="flex gap-1">
            <div class="relative w-[24px] h-[24px]">
                <UserAvatar
                    size="24px"
                    :src="history?.user?.avatar"
                />
                <span class="bg-[#ed1d49] text-white text-center text-xs font-semibold w-[19px] h-[12px] transform -translate-x-1/2 rounded-xl absolute left-[50%] top-[75%]" >
                    {{ history?.user?.lvl }}
                </span>
            </div>
            <span class="ellipsis flex-1 sm:hidden">
                {{ history?.user?.name }}
            </span>
        </div>
    </CasinoHistoryBodyCell>
    <!-- ↓ 押注金额列 -->
    <CasinoHistoryBodyCell
        class="flex-[0.8]"
        @click="showPharaoBonusGameAmount ? void 0 : onOpenModalClick()"
    >
        <CasinoHistoryCoinContent
            :history="history"
            :currency-name="history.currency"
            :amount="Number(history.amount)"
            :showPharaoBonusGameAmount="showPharaoBonusGameAmount"
        />
    </CasinoHistoryBodyCell>
    <!-- ↓ 返现倍数列 -->
    <CasinoHistoryBodyCell
        class=" inline-flex flex-[0_1_78px]"
        :class="[history.winAmount > 0 && 'text-[#1BB83D]']"
        @click="onOpenModalClick" 
    >
        <span class="bg-[#2a3546] ellipsis rounded-3xl px-2 text-[13px]">
            {{ `x${getFixed(Number(history.multi))}` }}
        </span>
    </CasinoHistoryBodyCell>
    <!-- ↓ 返现金额列 -->
    <CasinoHistoryBodyCell
        class="justify-between flex-[1] !pr-0"
        @click="onOpenModalClick" 
    >
        <CasinoHistoryCoinContent
            :history="history"
            :currency-name="history.currency"
            :amount="Number(getFixed(Number(history.winAmount)))"
            :validate-number-calss="history.winAmount > 0 ? 'text-[#1BB83D]' : '!text-[#55657e]'"
        />
    </CasinoHistoryBodyCell>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import moment from 'moment';
import {getGameApi} from '@/common/js/gameAbout'; 

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        default: () => ({}),
    },
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    userModalControl: Function,
    seeRoundDetail: Function,
});


// ↓ pharaoh 游戏专用，表示是用户是否买了特奖 
const showPharaoBonusGameAmount = computed(()=>{
    const {history} = props;
    const bResult = (
        history['bonusGameAmount'] > 0
        && history.game?.id === 12 // pharaoh
    ); 
    return bResult;
});

const onOpenModalClick = () => {
    const router = useRouter();
    const route = useRoute();
    const gameName = props.history.game.name || getGameApi();
    const data = `${gameName}:${props.history._id}`;
    router.push({
        replace: true,
        path: route.path,
        query: {
            modal: 'BetDetails',
            data,
        },
    });
};


</script>
